<template>
  <div class="section-task">
    <div class="task-item" v-for="(item, index) in task_list" :key="item.task_id">
      <div class="task-icon">
        <img :src="item.img" alt="" />
      </div>
      <div class="right-box">
        <div class="info-box">
          <div class="title">
            <div class="descr">{{ item.descr }}</div>
          </div>
          <div
            class="score-box"
            v-if="item.award_value != 0"
          >
            <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.536402 1.02537L7.15894 0.00741238C7.51581 -0.0473592 7.82216 0.2077 7.87697 0.564464L7.93213 0.929301H1.797C1.43599 0.929301 1.15418 1.21004 1.15418 1.57105V9.27535L0.00850916 1.76656C-0.0462627 1.40979 0.179489 1.08016 0.536402 1.02537Z"
                fill="#956E6E"
              />
              <path
                d="M2.07156 1.14291H8.77183C9.13289 1.14291 9.37842 1.4072 9.37842 1.76822V10.6476C9.37842 11.0086 9.13289 11.3111 8.77183 11.3111H2.07156C1.71046 11.3111 1.43183 11.0086 1.43183 10.6476V1.76822C1.43183 1.4072 1.71046 1.14291 2.07156 1.14291ZM2.95698 7.25969C3.0935 7.57811 3.28061 7.85635 3.5186 8.09417C3.75659 8.33222 4.03475 8.51939 4.35314 8.65585C4.67156 8.79233 5.01269 8.86058 5.37657 8.86058C5.74046 8.86058 6.08163 8.79233 6.40005 8.65585C6.71843 8.51939 6.99664 8.33222 7.23455 8.09417C7.4725 7.85632 7.65969 7.57811 7.79615 7.25969C7.93257 6.94123 8.00086 6.60019 8.00086 6.23629C8.00086 5.87241 7.93263 5.53131 7.79617 5.21282C7.65973 4.89443 7.47252 4.61619 7.23457 4.37837C6.99662 4.14038 6.71849 3.95327 6.40003 3.81681C6.08163 3.68029 5.74044 3.61202 5.37654 3.61202C5.01267 3.61202 4.67154 3.68029 4.35312 3.81673C4.03464 3.95318 3.75655 4.14038 3.51858 4.37837C3.28059 4.61621 3.09348 4.89443 2.95696 5.21278C2.82056 5.53124 2.75223 5.87243 2.75223 6.23631C2.75225 6.60019 2.82059 6.94123 2.95698 7.25969Z"
                fill="#956E6E"
              />
              <path
                d="M3.66552 5.756C3.68297 5.74719 3.70053 5.73478 3.71799 5.73122C3.73544 5.72423 3.75125 5.71434 3.76522 5.71434H3.80198H4.81498C4.83243 5.71434 4.84822 5.71376 4.86221 5.69977C4.88321 5.68574 4.8937 5.67495 4.8937 5.66098L5.18757 4.61286C5.1946 4.59541 5.20079 4.57958 5.20598 4.56379C5.21126 4.54807 5.21914 4.53177 5.22959 4.51423C5.24362 4.50026 5.26197 4.48471 5.28474 4.46724C5.30749 4.44976 5.33806 4.4394 5.37656 4.43584C5.41505 4.4394 5.44658 4.44991 5.47102 4.46739C5.49554 4.48486 5.51297 4.50067 5.5235 4.51464C5.53399 4.53218 5.54188 4.54888 5.54711 4.56458C5.55234 4.58037 5.5585 4.59695 5.56548 4.61449L5.8594 5.66425C5.8594 5.67815 5.86991 5.68572 5.89091 5.69984C5.90488 5.71374 5.92064 5.71434 5.93814 5.71434H6.95107C6.96861 5.71434 6.98698 5.72173 7.00623 5.7234C7.02547 5.72515 7.0456 5.73442 7.06657 5.74497C7.09804 5.75544 7.12261 5.77458 7.14004 5.79917C7.17155 5.83061 7.18381 5.86637 7.1768 5.90484C7.1768 5.93281 7.17242 5.95688 7.16366 5.97611C7.15497 5.99538 7.14536 6.01225 7.13489 6.02624C7.11735 6.04726 7.09112 6.06655 7.05611 6.08401L6.24256 6.61944C6.23558 6.62642 6.24389 6.63864 6.23517 6.6562C6.22641 6.67374 6.23825 6.69132 6.23825 6.70871V6.72447L6.54227 7.75843C6.54575 7.7759 6.54112 7.79162 6.54464 7.80566C6.5481 7.81971 6.54586 7.83544 6.54586 7.85291C6.54586 7.86686 6.54206 7.88363 6.5386 7.90273C6.53505 7.92206 6.52351 7.94387 6.50606 7.96839C6.49205 7.98935 6.47146 8.00592 6.44522 8.01836C6.41897 8.03043 6.39507 8.03664 6.37407 8.03664C6.32859 8.03316 6.29522 8.02519 6.27427 8.01304C6.25327 8.00082 6.23218 7.98587 6.21123 7.96839L5.41336 7.29127C5.40986 7.2808 5.39585 7.27548 5.37132 7.27548C5.35385 7.27548 5.34159 7.27905 5.3346 7.28603L4.49485 7.97363C4.47033 7.98766 4.4467 7.98243 4.42401 7.99465C4.40124 8.00695 4.37063 8.00003 4.33212 8.00003H4.32688C4.30586 8.00003 4.28313 8.01221 4.2587 7.99994C4.23411 7.98768 4.21497 7.98023 4.20085 7.95927C4.18346 7.93477 4.17205 7.91828 4.16673 7.9008C4.16158 7.88335 4.15891 7.86972 4.15891 7.85588C4.15891 7.83841 4.16073 7.82281 4.16417 7.80709C4.16772 7.7913 4.17289 7.7753 4.17987 7.75783L4.53685 6.71362C4.54026 6.71018 4.54208 6.70499 4.54208 6.69801C4.54208 6.68404 4.53768 6.66834 4.52896 6.65088C4.52014 6.63334 4.51232 6.62294 4.50534 6.61944L3.69701 6.08409C3.66556 6.07003 3.64104 6.05074 3.62357 6.02637C3.61308 6.0124 3.60261 5.99576 3.59204 5.97641C3.58157 5.95727 3.57631 5.93358 3.57631 5.90557C3.57631 5.86714 3.58855 5.83206 3.61301 5.80071C3.63051 5.77969 3.64798 5.76473 3.66552 5.756Z"
                fill="#956E6E"
              />
            </svg>
            <span class="score-desc">祝福卡+{{ item.award_value }}</span>
          </div>
        </div>
        <div
          class="finish-btn"
          :class="{'finished': item.state == 1}"
          @click="taskHandler(item, act_id)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { showMessage, executeProtocol } from '_lib/utils';
import { clickTask, reportData } from '_api/activity-common-template';


export default {
  props: {
    act_id: {
      type: String,
      default: '',
    },
    cd: {
      type: Object,
      default: () => ({}),
    },
    cc: {
      type: Object,
      default: () => ({}),
    },
    gc: {
      type: Object,
      default: () => ({}),
    },
    gd: {
      type: Object,
      default: () => ({}),
    },
    querys: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showExplanationIndex: -1,
      taskTipPos: {},
      times: 0,
    };
  },
  computed: {
    front_task_status() {
      return this.cd.front_task_status
        ? this.cd.front_task_status
        : { front_task_finished: true };
    },
    task_list() {
      // state= 1的排在后面
      return this.cd.task_list.slice().sort((a, b) => {
        if (a.state == b.state) {
          return a.index - b.index;
        } else {
          return a.state - b.state;
        }
      });
    },
  },
  methods: {
    taskHandler(task, task_act_id) {
      if (task.state == 1) {
        return;
      }

      this.reportData('.' + task.task_id);
      if (task.task_type === 17) {
        // this.$emit('hideTaskModal');
        this.$emit('scrollToAvatarDecoration')
        return
      }
      if (task.click_task == 1) {
        this.clickTaskHandler(task, task_act_id);
      } else if (task.href) {
        // 打开外链
        this.$emit('taskHandler', {
          is_jump_from_task: true,
          jump_from_task_ids: task.task_id,
          jump_from_act_id: task_act_id,
        })
        window.location.href = task.href;
      } else if (task.protocol) {
        this.$emit('taskHandler', {
          is_jump_from_task: true,
          jump_from_task_ids: task.task_id,
          jump_from_act_id: task_act_id,
        })
        executeProtocol(task.protocol);
      } else if (task.msg) {
        showMessage('ok', task.msg);
      }
    },
    clickTaskHandler(task, task_act_id) {
      this.times++;
      this.$toast.loading({
        duration: false,
      });
      clickTask({
        task_id: task.task_id,
        act_id: task_act_id || this.act_id,
        task_os_type: 'web',
        client_version: this.querys.version,
      }).then((res) => {
        if (res.data.status == 'ok') {
          var data = res.data.result;
          if (data && data.act == 'polling') {
            if (this.times > 20) {
              this.times = 0;
              showMessage('failed', '请求超时，请稍后再试');
            } else {
              setTimeout(() => {
                this.clickTaskHandler(task, task_act_id);
              }, 1500);
            }
          } else {
            this.$toast.close()
            this.$emit('reload')
          }
        } else {
          this.times = 0;
          this.$toast.close()
          showMessage('failed', res.data.msg);
        }
      });
    },
    showTaskTip(index) {
      this.showExplanationIndex = index;
      const elPos = this.$refs[`taskTip-${index}`][0].getBoundingClientRect();
      this.taskTipPos = {
        left: '-' + (elPos.x / screen.width) * 1000 + '%',
      };
    },
    showExpModal(msg) {
      this.explanation = msg;
    },
    reportData(id = '') {
      let index = 3
      if (!this.reportLock) {
        this.reportLock = true;
        reportData({
          type: '402',
          act_id: this.act_id,
          // 模块名称+时间戳+特殊id（比如任务模块的某个任务）+模块的index
          report_id:
            'cpt-task' +
            '-' +
            Date.parse(new Date()) +
            id +
            (index > -1 ? '-' + index : ''),
          heybox_id: this.querys.heybox_id,
        }).then(() => {
          this.reportLock = false;
        });
      }
    },
  },
}
</script>

<style lang="less">
.section-task {
  padding: 0 12px 120px;
  .task-item {
    display: flex;
    align-items: center;
    position: relative;
    height: 66px;
    border-radius: 10px;
    background: #FFE3D5;
    padding: 0 12px 0 14px;
    &:not(:last-child) {
      margin-bottom: 8px;
    }
    .task-icon {
      height: 33px;
      width: 33px;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
      }
    }
    .right-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      margin-left: 10px;
      padding: 12px 0 11px;
      .info-box {
        flex: 1;
        width: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .title {
          position: relative;
          line-height: 20px;
          .descr {
            display: inline;
            color: #EA2349;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            width: 90%;
          }
        }
        .score-box .score-desc {
          font-size: 11px;
          line-height: 15px;
          color: #956E6EF2;
        }
        .score-box {
          display: flex;
          align-items: center;
          margin-top: 3px;
          svg {
            position: relative;
          }
        }
        .score-desc {
          margin-left: 4px;
        }
      }
      .finish-btn {
        position: relative;
        height: 35px;
        width: 78px;
        background: center / 100% 100% url(https://imgheybox.max-c.com/oa/2025/01/21/a00cd49f3ed0c1eb3709a127b1c26381.png) no-repeat;
        &.finished {
          background: center / 100% 100% url(https://imgheybox.max-c.com/oa/2025/01/21/e90b1020ee59d77723f590563b6376d1.png) no-repeat;
        }
      }
    }
  }
}
</style>